import { isRecord } from "@/utils/isRecord";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import type { ToolPartBase } from "../ToolComponents";
import { isActionablePendingApproval } from "./approvalGate";
import { plural } from "./approvalValues";
import type { ApprovalView } from "./approvalView";
import { EntityApprovalBody, InlineRow } from "./EntityApprovalBody";

const text = (v: unknown) => (typeof v === "string" && v ? v : undefined);

// An import of an attached file, as Create a table shows a new table: each
// column with its type, and how many rows, read by the import's own planner.
export function FileImportBody({
  view,
  part,
}: {
  view: ApprovalView;
  part: ToolPartBase;
}) {
  const { spotGroup } = useSpotUser();
  const input = isRecord(part.input) ? part.input : {};
  const fileId = text(input.file_id);
  const mapping = isRecord(input.mapping)
    ? (input.mapping as Record<string, string | null>)
    : undefined;
  const plan = useRemoteData(
    DATA_KEYS.TABLES_IMPORT_PLAN,
    {
      path: { group_id: spotGroup.id },
      body: {
        file_id: fileId ?? "",
        name: text(input.name),
        table_id: text(input.table_id),
        mapping,
        skip_rows:
          typeof input.skip_rows === "number" ? input.skip_rows : undefined,
      },
    },
    {
      enabled: !!spotGroup.id && !!fileId && isActionablePendingApproval(part),
      retry: false,
    }
  ).data;
  return (
    <EntityApprovalBody view={view} input={part.input}>
      {plan && (
        <>
          <InlineRow label="Rows" edit={false}>
            {plural(plan.rows, "row")}
          </InlineRow>
          {plan.columns.map((column) => (
            <InlineRow
              key={column.name}
              label={column.label || column.name}
              edit={false}
            >
              {column.type_label}
              {column.filled_from &&
                column.filled_from !== (column.label || column.name) && (
                  <span className="text-muted-foreground">
                    {" "}
                    from {column.filled_from}
                  </span>
                )}
            </InlineRow>
          ))}
        </>
      )}
    </EntityApprovalBody>
  );
}
